<h2 mat-dialog-title>{{id? 'Update Stall' : 'Add Stall'}}</h2>
<form [formGroup]="StallForm" (ngSubmit)="onFormSubmit()">
    <mat-dialog-content class="content">
        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Stall Number</mat-label>
                <input [ngModel]="stall_num" formControlName="stall_num" matInput placeholder="Enter Stall Number">

            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Price</mat-label>
                <input [ngModel]="price" formControlName="price" matInput type="number" placeholder="Enter Price">

            </mat-form-field>
        </div>

        <div class="column">
            <mat-label>Size (L × W × H) in ft</mat-label>
            <div class="flex gap-2">
                <mat-form-field appearance="outline" class="w-24" style="margin-right: 5px;">
                    <mat-label>Length</mat-label>
                    <input matInput [ngModel]="length" formControlName="length" type="number" placeholder="L">
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-24" style="margin-right: 5px;">
                    <mat-label>Width</mat-label>
                    <input matInput [ngModel]="width" formControlName="width" type="number" placeholder="W">
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-24" style="margin-right: 5px;">
                    <mat-label>Height</mat-label>
                    <input matInput [ngModel]="height" formControlName="height" type="number" placeholder="H">
                </mat-form-field>
            </div>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Area (sq. ft)</mat-label>
                <input matInput [value]="calculatedArea" readonly>
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Description</mat-label>
                <input [ngModel]="description" formControlName="description" matInput placeholder="Enter Description">

            </mat-form-field>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions class="action" align="end">
        <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
        <button mat-raised-button type="submit" color="primary">{{id? 'Update' : 'Add'}}</button>
    </mat-dialog-actions>
</form>